import { faQuestionCircle, faSignOutAlt, faUserCircle } from '@fortawesome/free-solid-svg-icons';
import React, { useCallback } from 'react';
import { Col, Nav, Row } from 'react-bootstrap';
import { shallowEqual, useSelector } from 'react-redux';
import { getBasePath } from '../../utils/url-util';
import { ButtonIcon } from '../button-icon';
import { NavLink, useLocation, useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

export const NavBarLogin: React.FC<React.PropsWithChildren<any>> = () => {
  const userInfo = useSelector((state: any) => state.user.userInfo, shallowEqual);
  const { t } = useTranslation('auth');
  const navigate = useNavigate();
  const location = useLocation();
  const handleOnClick = useCallback(
    () => (location.pathname.includes('/profile') ? undefined : navigate('/profile')),
    [location, navigate]
  );

  return (
    <Nav className="navbar-login">
      <div className="menu-horizontal-div">
        {userInfo && userInfo.kc && (
          <Row className="d-flex justify-content-end text-end align-items-center">
            <Col className={'px-0'}>
              <ButtonIcon
                icon={faUserCircle}
                size="lg"
                style={{ color: 'white' }}
                tooltip={t('navbar.items.manageprofile')}
                onClick={handleOnClick}
              />
            </Col>

            <Col
              sm={'auto'}
              className="text-start px-2"
              style={{
                color: 'white',
                textAlign: 'left',
                whiteSpace: 'nowrap',
                maxWidth: '16em',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
              }}
            >
              <NavLink style={{ textDecoration: 'none', color: 'white' }} className="nav-link" to="/profile">
                {userInfo.firstName && userInfo.lastName ? userInfo.firstName.concat(' ').concat(userInfo.lastName) : ''}
              </NavLink>
            </Col>

            <Col className="text-start px-2">
              <ButtonIcon
                icon={faQuestionCircle}
                size="lg"
                onClick={() => window.open('https://www.cssf.lu/en/document/e-prospectus', '_blank')}
                style={{ color: 'white' }}
                tooltip={t('navbar.items.help')}
              />
            </Col>

            <Col sm={1} className="text-end px-0 me-4">
              <ButtonIcon
                icon={faSignOutAlt}
                size="lg"
                onClick={() => userInfo.kc.logout({ redirectUri: getBasePath() + '/maf-external-portal' })}
                style={{ color: 'white' }}
                tooltip={t('navbar.items.logout')}
              />
            </Col>
          </Row>
        )}
      </div>
    </Nav>
  );
};
